import { registerComponent } from './components-front'

registerComponent('filtered-article', _ => {
    document.querySelectorAll('.article-filter').forEach(filter => {
        const select = filter.querySelector('select')
        const button = filter.querySelector('button')
        button.addEventListener('click', _ => {
            document.querySelectorAll('.article').forEach(article => {
                const tags = JSON.parse(article.dataset.tags)
                if (isNaN(select.value) || tags.includes(+select.value)) {
                    article.classList.remove('d-none')
                } else {
                    article.classList.add('d-none')
                }
            })
        })
    })
})

document.addEventListener('DOMContentLoaded', _ => {
    const customSelect = document.querySelector('#custom-select');
    const customSelectText = customSelect.querySelector('.custom-select-text');
    customSelect.addEventListener('click', (ev) => {
        customSelect.parentNode.querySelector('#custom-select-option-box').classList.toggle('d-block');
    });

    const selectItems = document.querySelectorAll('#custom-select-option-box .custom-select-option a.dropdown-item');

    selectItems.forEach((elem) => {
        elem.addEventListener('click', (ev) => {
            let typeName = ev.target.parentNode.dataset.selectTypeName;
            if (!typeName) {
                typeName = 'All Resource Types';
            }
            customSelectText.textContent = typeName;
            customSelect.parentNode.querySelector('#custom-select-option-box').classList.toggle('d-block');
        })
    })
})